import React from 'react';
import { Stepper, Step, StepLabel, Box, styled } from '@mui/material';
import { PartnerTransferSection } from 'further-types/lp/partner-transfer';

const StepperContainer = styled(Box)({
  width: '800px',
});

const sectionLabels: Record<PartnerTransferSection, string> = {
  [PartnerTransferSection.PartnerTransfer]: 'Add partner transfer',
  [PartnerTransferSection.Investments]: 'Investments',
  [PartnerTransferSection.Income]: 'Income',
  [PartnerTransferSection.Expenses]: 'Expenses',
  [PartnerTransferSection.Fees]: 'Fees',
  [PartnerTransferSection.LinkedCapitalActions]: 'Linked capital actions',
  [PartnerTransferSection.GeneralCapitalActions]: 'General capital actions',
  [PartnerTransferSection.AdvanceSubscriptions]: 'Advance subscriptions',
  [PartnerTransferSection.Summary]: 'Review',
};

const PartnerTransferStepper: React.FC<{
  sections: Array<PartnerTransferSection>;
  activeSection: PartnerTransferSection;
}> = ({ sections, activeSection }) => {
  const activeIndex = sections.indexOf(activeSection);
  return (
    <StepperContainer>
      <Stepper activeStep={activeIndex}>
        {sections.map((section) => (
          <Step key={section}>
            <StepLabel>
              {section === activeSection ? sectionLabels[section] : ''}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </StepperContainer>
  );
};

export default PartnerTransferStepper;
